(ns vit-configurator.views.language
  (:require [re-frame.core :as re-frame]
            [vit-configurator.events :as events]
            [vit-configurator.subs :as subs]
            [vit-configurator.views.select-view :as sel-v]))

(def languages
  [[:none "Not Specified"]
   [:en "English"]
   [:es "Spanish"]
   [:ja "Japanese"]
   [:hy "Armenian"]
   [:zh "Chinese" ]
   [:fa "Farsi"]
   [:hi "Hindi"]
   [:km "Khmer"]
   [:ko "Korean"]
   [:ru "Russian"]
   [:tl "Tagalog"]
   [:th "Thai"]
   [:vi "Vietnamese"]])

(defn customizer
  []
  (let [options {:title-text "What default language do you want the tool to use?"
                 :description-text "The VIT will first attempt to use the language that the user's browser is set to use. If that language is unavailable, it can use this value as a fallback option. Finally it will use English if not otherwise specified. The user can still manually select a new language."
                 :subscription (re-frame/subscribe [::subs/language])
                 :event-kw ::events/set-language
                 :options languages
                 :card-id "language"
                 :select-id "language-select"
                 :select-label "Select a Language"}]
    (sel-v/select-card options)))
